import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserService } from '@app/data';
import { fadeIfAnimation } from '@app/animations';

@Component({
  selector: 'app-user-badge',
  templateUrl: './user-badge.component.html',
  styleUrls: ['./user-badge.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIfAnimation]
})
export class UserBadgeComponent implements OnInit {

  public user$ = this.user.user$;
  
  constructor(
    private user: UserService
  ) {}

  ngOnInit(): void {}
}
